<app-layout>
  <div class="headerForm">
    <div class="title">
      <app-titulo>Parametrização da Capacidade do Pátio</app-titulo>
      <div class="header-buttons">
        <app-botao style="width: 100%;" type="primario" class="button" text="Cadastrar Pátio" icon="assets/add.svg"
          (click)="onModalCadastro()"></app-botao>
      </div>
    </div>
    <div class="espacamento"></div>
  </div>

  <div class="desktop grid-outline">
    <section class="janela-list">
      <article class="janela-card" *ngFor="let item of items;">
        <div class="janela-card__grid">
          <!-- Janela -->
          <div class="janela-card__item janela-card__item--janela">
            <img class="janela-card__icon" src="assets/icons/janela-icon.svg" alt="Janela" />

            <div class="janela-card__text">
              <div class="janela-card__label">Janela</div>
              <div class="janela-card__value">
                {{ item.NU_TRNO | tipoTurno }}

              </div>
            </div>
          </div>

          <div class="janela-card__item">
            <img class="janela-card__icon" src="assets/icons/P-icon.svg" alt="Capacidade" width="30" height="30" />

            <div class="janela-card__text">
              <div class="janela-card__label">Capacidade</div>
              <div class="janela-card__value">{{ item.QT_CAPA }}</div>
            </div>
          </div>

          <div class="janela-card__item">
            <img class="janela-card__icon" src="assets/icons/carro_icon.svg" alt="Qtd. Agendamento" width="30"
              height="30" />

            <div class="janela-card__text">
              <div class="janela-card__label">Qtd. Agendamento</div>
              <div class="janela-card__value">{{ item.QT_AGND }}</div>
            </div>
          </div>

          <div class="janela-card__item">
            <img src="assets/icons/cam-icon.svg" alt="Produto" width="38" height="38" />

            <div class="janela-card__text" [matTooltip]="item.TX_CRGA || 'Não informado'">
              <div class="janela-card__label">Produto</div>
              <div class="janela-card__value">{{ item.TX_CRGA }}</div>
            </div>
          </div>
          <div class="janela-card__item janela-card__item--destinatario">
            <div class="janela-card__icon janela-card__icon--destinatario" aria-hidden="true">
              <svg viewBox="0 0 24 24" focusable="false">
                <path
                  d="M12 12a4 4 0 1 0-4-4 4 4 0 0 0 4 4Zm0 2c-3.33 0-6 2.01-6 4.5 0 .28.22.5.5.5h11c.28 0 .5-.22.5-.5 0-2.49-2.67-4.5-6-4.5Z" />
              </svg>
            </div>

            <div class="janela-card__text" [matTooltip]="item.NM_DTNR || 'Não informado'">
              <div class="janela-card__label">Destinatário</div>
              <div class="janela-card__value" >
                {{ item.NM_DTNR || 'Não informado' }}
              </div>
            </div>
          </div>
          <!-- Menu -->
          <button type="button" class="janela-card__menu" aria-label="Mais ações" [matMenuTriggerFor]="menu"
            (click)="$event.stopPropagation()">
            <img class="janela-card__menu-icon" src="assets/icons/more_vert.svg" alt="" />
          </button>
          <mat-menu #menu="matMenu">
            <button mat-menu-item (click)="editarItem(item)">
              <mat-icon>edit</mat-icon>
              <span>Editar</span>
            </button>
            <button mat-menu-item (click)="excluirItem(item)">
              <mat-icon>delete</mat-icon>
              <span>Excluir</span>
            </button>

          </mat-menu>
        </div>
      </article>
    </section>

  </div>
</app-layout>

<app-loader [isLoading]="isLoading"></app-loader>